import React, { useEffect, useMemo, useState } from 'react'
import './PersonalDetails.scss'
import dummyProfile from '../dummyProfile.png'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { UpdateUserProfile, UpdateUserProfilePic, getUserProfile, getUserProfilePic, userLogout } from '../../../redux/network/userApi';
import { setAlertMessage, setAlertType } from '../../../redux/reducers/alertSlice';
import { setIsLoginDialog } from '../../../redux/reducers/loginSlice';
import { Box, CircularProgress } from '@mui/material';
import { DateTime } from "luxon";


const PersonalDetails = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const jwtToken = localStorage.getItem("BQS_TOKEN");
    const UserId = localStorage.getItem("BQS__ID");
    console.log("userId", UserId);

    useEffect(() => {
        if (jwtToken) {
            dispatch(getUserProfile(jwtToken));
        } else {
            navigate("/");
        }
    }, [jwtToken]);

    useEffect(() => {
        if (jwtToken) {
            dispatch(getUserProfilePic(jwtToken));
        } else {
            navigate("/");
        }
    }, [jwtToken]);

    const userData = useSelector((state) => state.user.profile);
    const userPicData = useSelector((state) => state.user.profilePic);

    const { isProfileStarted, isProfilePicError, profilePicError, profilePicUrl } = userPicData;
    const { isStarted, isError, error, value } = userData;
    const { profileData, phone, email } = value;

    console.log("userPicData", userPicData);

    const getFullname = (Fname, Mname, LName) => {
        let fullname = "";

        if (Fname && Fname.length >= 1) {
            fullname += Fname;
        }

        if (Mname && Mname.length >= 1) {
            if (fullname.length > 0) {
                fullname += " " + Mname;
            } else {
                fullname = Mname;
            }
        }

        if (LName && LName.length >= 1) {
            if (fullname.length > 0) {
                fullname += " " + LName;
            } else {
                fullname = LName;
            }
        }
        return fullname;
    };

    console.log("userData", userData);

    const initialState = useMemo(() => {
        return {
            email: email?.email || "",
            dob: profileData?.dob || "",
            gender: profileData?.gender || "",
            height: profileData?.height || "",
            fullname: getFullname(profileData?.name?.firstName, profileData?.name?.middleName, profileData?.name?.lastName) || "",
            weight: profileData?.weight || "",
            areasOfImprovement: profileData?.gamingProfile?.areasOfImprovement || [],
            exp: profileData?.gamingProfile?.exp || "",
            goal: profileData?.gamingProfile?.goal || "",
            coachName: profileData?.gamingProfile?.coachName || "",
            injurySummary: profileData?.gamingProfile?.injurySummary || "",
            _id: UserId
        };
    }, [userData]);

    const [formData, setFormData] = useState(initialState);
    const [errorMsg, setErrorMsg] = useState("");
    const [isEditable, setIsEditable] = useState(false);

    //set the formData when userData change
    useEffect(() => {
        setFormData(initialState);
    }, [initialState]);

    console.log("formData", formData);

    const handleUpdateProfilePic = (e) => {
        const file = e.target.files[0];
        console.log(file);
        dispatch(UpdateUserProfilePic(jwtToken, file));
    };

    const handleInputChange = (event) => {
        const { value, name } = event.target;
        console.log(value, name);
        if (name === "dob") {

            if (value === "") {
                // Clear error message and update form data
                setErrorMsg("");
                const newData = { ...formData };
                newData["dob"] = value;
                setFormData(newData);
            } else {
                let formattedDate;
                if (value.length < formData["dob"].length) {
                    // Handle backspace when length is decreasing
                    const newData = { ...formData };
                    newData["dob"] = value;
                    setFormData(newData);
                } else if (value.length === 2) {
                    // Day validation
                    if (parseInt(value) > 31) {
                        setErrorMsg("Please enter a correct Day");
                    } else {
                        formattedDate = value + "-";
                        const newData = { ...formData };
                        newData["dob"] = formattedDate;
                        setFormData(newData);
                    }
                } else if (value.length === 5) {
                    // Month validation
                    if (value.slice(3) > 12) {
                        setErrorMsg("Please enter a correct Month");
                    } else {
                        formattedDate = value + "-";
                        const newData = { ...formData };
                        newData["dob"] = formattedDate;
                        setFormData(newData);
                    }
                } else if (value.length === 11) {
                    // Year validation
                    const year = parseInt(value.slice(6));
                    const currentYear = new Date().getFullYear();
                    if (year > currentYear) {
                        setErrorMsg("Please enter a correct Year");
                    }
                } else {
                    const newData = { ...formData };
                    newData["dob"] = value;
                    setFormData(newData);
                }
            }
        } else {
            setFormData({
                ...formData,
                [name]: value
            });
        }
    };

    const handleSaveProfile = () => {
        // Validation checks
        if (formData.fullname.length <= 0) {
            dispatch(setAlertMessage("Please enter name"));
            dispatch(setAlertType("error"));
            return;
        }

        if (!formData.email) {
            dispatch(setAlertMessage("Please enter email"));
            dispatch(setAlertType("error"));
            return;
        }

        if (!/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(formData.email)) {
            dispatch(setAlertMessage("Please enter a valid email address"));
            dispatch(setAlertType("error"));
            return;
        }

        // dob validation
        if (/^\d{2}\-\d{2}\-\d{4}$/.test(formData.dob)) {
            const parts = formData.dob.split('-');
            const enteredDate = new Date(parts[2], parts[1] - 1, parts[0]);
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            if (enteredDate > today) {
                dispatch(setAlertMessage("Date cannot be greater than today"));
                dispatch(setAlertType("error"));
                return;
            }

            const isValid = DateTime.fromFormat(formData.dob, "dd-MM-yyyy").isValid;
            if (!isValid) {
                dispatch(setAlertMessage("Please enter a valid date in DD-MM-YYYY format"));
                dispatch(setAlertType("error"));
                return;
            }
        } else {
            dispatch(setAlertMessage("Please enter a valid date in DD-MM-YYYY format"));
            dispatch(setAlertType("error"));
            return;
        }

        // Splitting full name
        const fullnameArr = formData.fullname.trim().split(" ");
        let firstName = fullnameArr[0];
        let middleName = "";
        let lastName = "";

        if (fullnameArr.length === 2) {
            lastName = fullnameArr[1];
        } else if (fullnameArr.length === 3) {
            middleName = fullnameArr[1];
            lastName = fullnameArr[2];
        } else if (fullnameArr.length > 3) {
            middleName = fullnameArr[1];
            lastName = fullnameArr.slice(2).join(" ");
        }

        // Combined Update API Call
        const body = {
            email: {
                email: formData.email
            },
            profileData: {
                dob: formData.dob,
                gender: formData.gender,
                height: formData.height,
                name: {
                    firstName: firstName,
                    middleName: middleName,
                    lastName: lastName
                },
                weight: formData.weight,
                gamingProfile: {
                    areasOfImprovement: formData.areasOfImprovement,
                    exp: formData.exp,
                    goal: formData.goal,
                    injurySummary: formData.injurySummary,
                    coachName: formData.coachName,
                    _id: UserId
                }
            }
        };

        console.log("Profile Update Body", body);
        dispatch(UpdateUserProfile(jwtToken, body));
        setIsEditable(false);
    };

    const toggleEdit = () => {
        setIsEditable(!isEditable);
    };

    const handleLogout = (e) => {
        userLogout(jwtToken).then(res => {
            console.log(res)
            return res.json();
        }).then(response => {
            localStorage.clear()
        }).catch(error => {
            localStorage.clear()
        }).finally(() => {
            dispatch(setIsLoginDialog(true))
            localStorage.clear()
            navigate("/");
        })
    }

    return (
        <>
            {/* Main Container - Dark Premium Design with Animations */}
            <div className="w-full min-h-screen relative overflow-hidden pt-28 pb-12 px-4 sm:px-6 lg:px-8" style={{ background: 'linear-gradient(135deg, #0a1f14 0%, #0d2818 50%, #051a0d 100%)' }}>

                {/* World-Class Animation Keyframes */}
                <style>{`
                    @keyframes particleFloat {
                        0%, 100% { transform: translate(0, 0); opacity: 0.3; }
                        25% { transform: translate(30px, -50px); opacity: 0.8; }
                        50% { transform: translate(-20px, -100px); opacity: 0.6; }
                        75% { transform: translate(40px, -75px); opacity: 0.7; }
                    }
                    
                    @keyframes auroraPulse {
                        0%, 100% { opacity: 0.3; filter: blur(80px) hue-rotate(0deg); transform: scale(1) translateY(0); }
                        33% { opacity: 0.5; filter: blur(100px) hue-rotate(30deg); transform: scale(1.2) translateY(-20px); }
                        66% { opacity: 0.4; filter: blur(90px) hue-rotate(-30deg); transform: scale(1.1) translateY(20px); }
                    }
                    
                    @keyframes meshShift {
                        0%, 100% { transform: translate(0, 0) scale(1); }
                        50% { transform: translate(50px, 30px) scale(1.05); }
                    }
                    
                    @keyframes nodeGlow {
                        0%, 100% { opacity: 0.4; transform: scale(1); box-shadow: 0 0 20px rgba(204,255,0,0.3); }
                        50% { opacity: 0.8; transform: scale(1.3); box-shadow: 0 0 40px rgba(204,255,0,0.6); }
                    }
                    
                    @keyframes lineConnect {
                        0% { stroke-dashoffset: 500; opacity: 0.2; }
                        50% { opacity: 0.6; }
                        100% { stroke-dashoffset: 0; opacity: 0.2; }
                    }
                    
                    @keyframes radialBurst {
                        0% { transform: scale(0.8) rotate(0deg); opacity: 0.2; }
                        50% { transform: scale(1.2) rotate(180deg); opacity: 0.4; }
                        100% { transform: scale(0.8) rotate(360deg); opacity: 0.2; }
                    }
                    
                    @keyframes depthLayer {
                        0%, 100% { transform: translateZ(0) translateY(0); opacity: 0.15; }
                        50% { transform: translateZ(50px) translateY(-30px); opacity: 0.3; }
                    }
                `}</style>

                {/* Epic Background Layers */}
                <div className="absolute inset-0 overflow-hidden pointer-events-none" style={{ perspective: '1000px' }}>

                    {/* Aurora Gradient Layers */}
                    <div className="absolute -top-1/2 -right-1/4 w-[900px] h-[900px] rounded-full"
                        style={{
                            background: 'radial-gradient(circle, rgba(16,185,129,0.4) 0%, rgba(5,150,105,0.2) 50%, transparent 70%)',
                            animation: 'auroraPulse 15s ease-in-out infinite',
                            filter: 'blur(80px)'
                        }} />
                    <div className="absolute top-1/4 -left-1/4 w-[800px] h-[800px] rounded-full"
                        style={{
                            background: 'radial-gradient(circle, rgba(52,211,153,0.35) 0%, rgba(16,185,129,0.15) 50%, transparent 70%)',
                            animation: 'auroraPulse 18s ease-in-out infinite 5s',
                            filter: 'blur(90px)'
                        }} />
                    <div className="absolute bottom-1/4 right-1/3 w-[700px] h-[700px] rounded-full"
                        style={{
                            background: 'radial-gradient(circle, rgba(110,231,183,0.3) 0%, rgba(52,211,153,0.12) 50%, transparent 70%)',
                            animation: 'auroraPulse 20s ease-in-out infinite 10s',
                            filter: 'blur(100px)'
                        }} />

                    {/* Animated Mesh Grid */}
                    <div className="absolute inset-0 opacity-10" style={{ animation: 'meshShift 40s ease-in-out infinite' }}>
                        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
                            <defs>
                                <pattern id="meshGrid" x="0" y="0" width="80" height="80" patternUnits="userSpaceOnUse">
                                    <circle cx="40" cy="40" r="1.5" fill="#ccff00" opacity="0.6" />
                                    <line x1="40" y1="0" x2="40" y2="80" stroke="#ccff00" strokeWidth="0.5" opacity="0.3" />
                                    <line x1="0" y1="40" x2="80" y2="40" stroke="#ccff00" strokeWidth="0.5" opacity="0.3" />
                                </pattern>
                            </defs>
                            <rect width="100%" height="100%" fill="url(#meshGrid)" />
                        </svg>
                    </div>

                    {/* Particle Network System */}
                    {[...Array(12)].map((_, i) => (
                        <div
                            key={`particle-${i}`}
                            className="absolute w-3 h-3 rounded-full"
                            style={{
                                left: `${15 + (i * 7)}%`,
                                top: `${20 + (i * 5) % 60}%`,
                                background: 'radial-gradient(circle, #ccff00 0%, rgba(204,255,0,0.3) 70%, transparent 100%)',
                                animation: `particleFloat ${8 + i * 2}s ease-in-out infinite ${i * 0.5}s`,
                                boxShadow: '0 0 20px rgba(204,255,0,0.5)'
                            }}
                        />
                    ))}

                    {/* Connecting Lines Between Particles */}
                    <svg className="absolute inset-0 w-full h-full opacity-20" xmlns="http://www.w3.org/2000/svg">
                        <defs>
                            <linearGradient id="lineGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" stopColor="#ccff00" stopOpacity="0.8" />
                                <stop offset="100%" stopColor="#10b981" stopOpacity="0.2" />
                            </linearGradient>
                        </defs>
                        {[...Array(8)].map((_, i) => (
                            <line
                                key={`line-${i}`}
                                x1={`${15 + i * 12}%`}
                                y1={`${25 + i * 8}%`}
                                x2={`${25 + i * 11}%`}
                                y2={`${35 + i * 7}%`}
                                stroke="url(#lineGrad)"
                                strokeWidth="1"
                                strokeDasharray="5,3"
                                style={{ animation: `lineConnect ${10 + i * 2}s linear infinite ${i * 1.5}s` }}
                            />
                        ))}
                    </svg>

                    {/* Glowing Nodes */}
                    {[...Array(6)].map((_, i) => (
                        <div
                            key={`node-${i}`}
                            className="absolute w-4 h-4 rounded-full bg-emerald-400"
                            style={{
                                left: `${20 + i * 15}%`,
                                top: `${30 + (i * 10) % 50}%`,
                                animation: `nodeGlow ${6 + i}s ease-in-out infinite ${i * 2}s`
                            }}
                        />
                    ))}

                    {/* Radial Burst Patterns */}
                    <div className="absolute top-1/3 right-1/4 w-96 h-96 opacity-15" style={{ animation: 'radialBurst 30s linear infinite' }}>
                        <svg width="100%" height="100%" viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg">
                            {[...Array(12)].map((_, i) => (
                                <line
                                    key={`burst-${i}`}
                                    x1="200"
                                    y1="200"
                                    x2={200 + Math.cos((i * 30 * Math.PI) / 180) * 180}
                                    y2={200 + Math.sin((i * 30 * Math.PI) / 180) * 180}
                                    stroke="#ccff00"
                                    strokeWidth="2"
                                    opacity={0.3 + (i % 3) * 0.1}
                                />
                            ))}
                            <circle cx="200" cy="200" r="150" stroke="#ccff00" strokeWidth="1" fill="none" opacity="0.2" />
                            <circle cx="200" cy="200" r="100" stroke="#ccff00" strokeWidth="1" fill="none" opacity="0.3" />
                            <circle cx="200" cy="200" r="50" stroke="#ccff00" strokeWidth="1.5" fill="none" opacity="0.4" />
                        </svg>
                    </div>

                    {/* 3D Depth Layers */}
                    <div className="absolute bottom-1/3 left-1/5 w-80 h-80 opacity-12" style={{ animation: 'depthLayer 25s ease-in-out infinite', transformStyle: 'preserve-3d' }}>
                        <svg width="100%" height="100%" viewBox="0 0 300 300" xmlns="http://www.w3.org/2000/svg">
                            <defs>
                                <radialGradient id="depthGrad">
                                    <stop offset="0%" stopColor="#ccff00" stopOpacity="0.6" />
                                    <stop offset="100%" stopColor="#10b981" stopOpacity="0.1" />
                                </radialGradient>
                            </defs>
                            <polygon points="150,30 270,90 270,210 150,270 30,210 30,90" fill="url(#depthGrad)" opacity="0.3" />
                            <polygon points="150,60 240,105 240,195 150,240 60,195 60,105" fill="none" stroke="#ccff00" strokeWidth="1.5" opacity="0.5" />
                            <polygon points="150,90 210,120 210,180 150,210 90,180 90,120" fill="none" stroke="#ccff00" strokeWidth="1" opacity="0.4" />
                        </svg>
                    </div>

                    {/* Geometric Constellation */}
                    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] opacity-8" style={{ animation: 'meshShift 50s ease-in-out infinite reverse' }}>
                        <svg width="100%" height="100%" viewBox="0 0 600 600" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="300" cy="100" r="4" fill="#ccff00" opacity="0.8" />
                            <circle cx="450" cy="200" r="3" fill="#ccff00" opacity="0.7" />
                            <circle cx="500" cy="400" r="4" fill="#ccff00" opacity="0.8" />
                            <circle cx="300" cy="500" r="3" fill="#ccff00" opacity="0.7" />
                            <circle cx="100" cy="400" r="4" fill="#ccff00" opacity="0.8" />
                            <circle cx="150" cy="200" r="3" fill="#ccff00" opacity="0.7" />
                            <line x1="300" y1="100" x2="450" y2="200" stroke="#ccff00" strokeWidth="1" opacity="0.3" />
                            <line x1="450" y1="200" x2="500" y2="400" stroke="#ccff00" strokeWidth="1" opacity="0.3" />
                            <line x1="500" y1="400" x2="300" y2="500" stroke="#ccff00" strokeWidth="1" opacity="0.3" />
                            <line x1="300" y1="500" x2="100" y2="400" stroke="#ccff00" strokeWidth="1" opacity="0.3" />
                            <line x1="100" y1="400" x2="150" y2="200" stroke="#ccff00" strokeWidth="1" opacity="0.3" />
                            <line x1="150" y1="200" x2="300" y2="100" stroke="#ccff00" strokeWidth="1" opacity="0.3" />
                        </svg>
                    </div>

                </div>

                {/* Premium Noise Texture Overlay */}
                <div className="absolute inset-0 opacity-[0.03]" style={{
                    backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' /%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)' opacity='0.3'/%3E%3C/svg%3E")`,
                    backgroundSize: '200px 200px'
                }} />

                <div className="max-w-7xl mx-auto relative z-10">
                    {/* Header with floating action button */}
                    <div className="flex flex-col md:flex-row justify-between items-center mb-12 gap-6 px-4">
                        <div className="flex-1 hidden md:block"></div>
                        <h1 className="text-5xl font-black text-white text-center" style={{ textShadow: '0 4px 20px rgba(0,0,0,0.3)', color: '#ccff00' }}>PROFILE</h1>
                        <div className="flex-1 flex justify-end items-center gap-4">
                            {isEditable ? (
                                <button
                                    onClick={handleSaveProfile}
                                    className="flex items-center gap-2 py-3 px-6 bg-gradient-to-br from-[#026B33] to-[#00A13A] text-white font-bold rounded-xl shadow-lg shadow-emerald-500/30 hover:shadow-xl hover:shadow-emerald-500/40 transition-all whitespace-nowrap"
                                >
                                    Save <i className="fa-regular fa-floppy-disk"></i>
                                </button>
                            ) : (
                                <button
                                    onClick={toggleEdit}
                                    className="flex items-center gap-2 py-3 px-6 bg-white/10 border border-white/20 text-white font-bold rounded-xl hover:bg-white/20 transition-all whitespace-nowrap"
                                >
                                    Edit <i className="fa-solid fa-file-pen"></i>
                                </button>
                            )}
                            <button
                                onClick={handleLogout}
                                className="flex items-center gap-2 py-3 px-6 bg-red-500/10 border border-red-500/20 text-red-500 font-bold rounded-xl hover:bg-red-500/20 transition-all whitespace-nowrap"
                            >
                                Log Out <i className="fa-solid fa-arrow-right-from-bracket"></i>
                            </button>
                        </div>
                    </div>

                    {/* Two Column Grid Layout */}
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                        {/* Personal Details Card */}
                        <div className="backdrop-blur-xl rounded-3xl p-8 border border-white/10 shadow-2xl" style={{ background: 'linear-gradient(135deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.03) 100%)', boxShadow: '0 25px 50px -12px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.1)' }}>
                            {/* Header */}
                            <div className="flex justify-between items-center mb-6">
                                <h2 className="text-2xl font-bold text-white">Personal Details</h2>
                            </div>

                            {/* Profile Picture */}
                            <div className="flex items-center gap-6 mb-8">
                                <div className="w-32 h-32 rounded-full border-2 border-emerald-400 flex justify-center items-center overflow-hidden" style={{ boxShadow: '0 0 30px rgba(16,185,129,0.3)' }}>
                                    {isProfileStarted ? (
                                        <Box sx={{ display: 'flex', flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                                            <CircularProgress sx={{ color: '#10b981' }} />
                                            <p className="text-white text-sm mt-2">Loading...</p>
                                        </Box>
                                    ) : (
                                        <div
                                            style={{
                                                backgroundImage: `url(${(!profilePicUrl || isProfilePicError) ? dummyProfile : profilePicUrl})`,
                                                backgroundSize: 'cover',
                                                backgroundPosition: 'center',
                                            }}
                                            className="w-full h-full"
                                        />
                                    )}
                                </div>
                                {isProfilePicError && console.error("Profile Pic Error:", profilePicError)}
                                <label htmlFor="profileImg" className="text-lg font-bold cursor-pointer transition-all" style={{ color: '#ccff00' }}>
                                    Change Photo
                                </label>
                                <input id="profileImg" type="file" accept="image/*" onChange={handleUpdateProfilePic} className="hidden" />
                            </div>

                            {/* Form Fields */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                {/* Name */}
                                <div>
                                    <label htmlFor="name" className="block text-sm font-semibold text-white mb-2">Name</label>
                                    <input
                                        id="name"
                                        type="text"
                                        value={formData.fullname}
                                        name="fullname"
                                        disabled={!isEditable}
                                        onChange={handleInputChange}
                                        className="w-full px-4 py-3.5 bg-white/10 border border-white/20 rounded-xl focus:ring-2 focus:ring-emerald-500 focus:border-emerald-400 outline-none transition-all text-white placeholder-white/50 backdrop-blur-sm disabled:opacity-50 disabled:cursor-not-allowed"
                                    />
                                </div>

                                {/* Date of Birth */}
                                <div>
                                    <label htmlFor="dob" className="block text-sm font-semibold text-white mb-2">Date of Birth</label>
                                    <input
                                        id="dob"
                                        type="text"
                                        value={formData?.dob}
                                        disabled={!isEditable}
                                        onChange={handleInputChange}
                                        name="dob"
                                        placeholder="DD-MM-YYYY"
                                        className="w-full px-4 py-3.5 bg-white/10 border border-white/20 rounded-xl focus:ring-2 focus:ring-emerald-500 focus:border-emerald-400 outline-none transition-all text-white placeholder-white/50 backdrop-blur-sm disabled:opacity-50 disabled:cursor-not-allowed"
                                    />
                                </div>

                                {/* Gender */}
                                <div className="md:col-span-2">
                                    <label className="block text-sm font-semibold text-white mb-2">Gender</label>
                                    <div className="flex gap-3">
                                        {['Male', 'Female', 'Other'].map((g) => (
                                            <button
                                                key={g}
                                                type="button"
                                                onClick={() => isEditable && setFormData({ ...formData, gender: g })}
                                                disabled={!isEditable}
                                                className={`flex-1 py-2 px-4 rounded-xl font-medium transition-all ${formData?.gender === g
                                                    ? 'bg-emerald-400 border border-emerald-400'
                                                    : 'bg-white/10 text-white/70 border border-white/10 hover:bg-white/20'
                                                    } disabled:opacity-50 disabled:cursor-not-allowed`}
                                                style={formData?.gender === g ? { color: '#ccff00' } : {}}
                                            >
                                                {g}
                                            </button>
                                        ))}
                                    </div>
                                </div>

                                {/* Weight */}
                                <div>
                                    <label htmlFor="weight" className="block text-sm font-semibold text-white mb-2">Weight (kg)</label>
                                    <input
                                        id="weight"
                                        type="text"
                                        value={formData.weight}
                                        name="weight"
                                        disabled={!isEditable}
                                        onChange={handleInputChange}
                                        className="w-full px-4 py-3.5 bg-white/10 border border-white/20 rounded-xl focus:ring-2 focus:ring-emerald-500 focus:border-emerald-400 outline-none transition-all text-white placeholder-white/50 backdrop-blur-sm disabled:opacity-50 disabled:cursor-not-allowed"
                                    />
                                </div>

                                {/* Height */}
                                <div>
                                    <label htmlFor="height" className="block text-sm font-semibold text-white mb-2">Height (cm)</label>
                                    <input
                                        id="height"
                                        type="text"
                                        value={formData.height}
                                        name="height"
                                        disabled={!isEditable}
                                        onChange={handleInputChange}
                                        className="w-full px-4 py-3.5 bg-white/10 border border-white/20 rounded-xl focus:ring-2 focus:ring-emerald-500 focus:border-emerald-400 outline-none transition-all text-white placeholder-white/50 backdrop-blur-sm disabled:opacity-50 disabled:cursor-not-allowed"
                                    />
                                </div>

                                {/* Email */}
                                <div className="md:col-span-2">
                                    <label htmlFor="email" className="block text-sm font-semibold text-white mb-2">Email</label>
                                    <input
                                        id="email"
                                        type="text"
                                        value={formData.email}
                                        name="email"
                                        disabled={!isEditable}
                                        onChange={handleInputChange}
                                        className="w-full px-4 py-3.5 bg-white/10 border border-white/20 rounded-xl focus:ring-2 focus:ring-emerald-500 focus:border-emerald-400 outline-none transition-all text-white placeholder-white/50 backdrop-blur-sm disabled:opacity-50 disabled:cursor-not-allowed"
                                    />
                                </div>

                                {/* Phone Number */}
                                <div className="md:col-span-2">
                                    <label htmlFor="phone" className="block text-sm font-semibold text-white mb-2">Phone Number</label>
                                    <div className="flex gap-2">
                                        <select
                                            disabled
                                            className="px-3 py-3.5 bg-white/10 border border-white/20 rounded-xl text-white opacity-50 cursor-not-allowed"
                                        >
                                            <option>+91</option>
                                        </select>
                                        <input
                                            id="phone"
                                            type="text"
                                            value={phone?.number}
                                            disabled
                                            className="flex-1 px-4 py-3.5 bg-white/10 border border-white/20 rounded-xl text-white opacity-50 cursor-not-allowed"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Additional Details Card */}
                        <div className="backdrop-blur-xl rounded-3xl p-8 border border-white/10 shadow-2xl flex flex-col h-full" style={{ background: 'linear-gradient(135deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.03) 100%)', boxShadow: '0 25px 50px -12px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.1)' }}>
                            {/* Header */}
                            <div className="flex justify-between items-center mb-6">
                                <h2 className="text-2xl font-bold text-white">Additional Details</h2>

                            </div>

                            {/* Form Fields */}
                            <div className="flex-1 flex flex-col gap-6">
                                {/* Experience and Coach Name */}
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    {/* Experience */}
                                    <div>
                                        <label htmlFor="exp" className="block text-sm font-semibold text-white mb-2">Badminton Experience</label>
                                        <select
                                            id="exp"
                                            value={formData?.exp}
                                            onChange={handleInputChange}
                                            name="exp"
                                            disabled={!isEditable}
                                            className="w-full px-4 py-3.5 bg-white/10 border border-white/20 rounded-xl focus:ring-2 focus:ring-emerald-500 focus:border-emerald-400 outline-none transition-all text-white placeholder-white/50 backdrop-blur-sm disabled:opacity-50 disabled:cursor-not-allowed"
                                        >
                                            <option value="Beginner">Beginner</option>
                                            <option value="Intermediate">Intermediate</option>
                                            <option value="Experienced">Experienced</option>
                                        </select>
                                    </div>

                                    {/* Coach Name */}
                                    <div>
                                        <label htmlFor="headCoach" className="block text-sm font-semibold text-white mb-2">Head Coach of your Academy</label>
                                        <input
                                            id="headCoach"
                                            type="text"
                                            value={formData.coachName}
                                            name="coachName"
                                            disabled={!isEditable}
                                            onChange={handleInputChange}
                                            className="w-full px-4 py-3.5 bg-white/10 border border-white/20 rounded-xl focus:ring-2 focus:ring-emerald-500 focus:border-emerald-400 outline-none transition-all text-white placeholder-white/50 backdrop-blur-sm disabled:opacity-50 disabled:cursor-not-allowed"
                                        />
                                    </div>
                                </div>

                                {/* Goals */}
                                <div className="flex-1 flex flex-col">
                                    <label htmlFor="goals" className="block text-sm font-semibold text-white mb-2">What are your goals with badminton?</label>
                                    <textarea
                                        id="goals"
                                        placeholder="What are your goals with badminton?..."
                                        value={formData?.goal}
                                        onChange={handleInputChange}
                                        name="goal"
                                        disabled={!isEditable}
                                        maxLength={256}
                                        rows={4}
                                        className="w-full h-full px-4 py-3.5 bg-white/10 border border-white/20 rounded-xl focus:ring-2 focus:ring-emerald-500 focus:border-emerald-400 outline-none transition-all text-white placeholder-white/50 backdrop-blur-sm disabled:opacity-50 disabled:cursor-not-allowed resize-none"
                                    />
                                </div>

                                {/* Injury Summary */}
                                <div className="flex-1 flex flex-col">
                                    <label htmlFor="injurySummary" className="block text-sm font-semibold text-white mb-2">Do you have any present or past injuries? If yes, please specify.</label>
                                    <textarea
                                        id="injurySummary"
                                        placeholder="Do you have any present or past injuries? If yes, please specify..."
                                        value={formData?.injurySummary}
                                        onChange={handleInputChange}
                                        name="injurySummary"
                                        disabled={!isEditable}
                                        rows={4}
                                        className="w-full h-full px-4 py-3.5 bg-white/10 border border-white/20 rounded-xl focus:ring-2 focus:ring-emerald-500 focus:border-emerald-400 outline-none transition-all text-white placeholder-white/50 backdrop-blur-sm disabled:opacity-50 disabled:cursor-not-allowed resize-none"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PersonalDetails;
